import { type App, createApp, h } from "vue";

import type { ComponentCustomProperties } from "@vue/runtime-core";

/**
 * Unmounted Vue app used only as a holder for `config.globalProperties`, so helper / SignalR /
 * plain TS can access the same `$storeInstance`, `$LoggedInUser`, etc. before or outside the
 * mounted root app (legacy parity with the MSP `PrototypeInstance` pattern).
 *
 * Do **not** call `mount()` on this instance.
 */
export default class PrototypeInstance {
  private static instance: App | null = null;

  private constructor() {
    /* singleton */
  }

  public static getInstance(): App {
    if (!this.instance) {
      this.instance = createApp({
        name: "HelperGlobalPropertiesShell",
        render: () => h("div", { style: "display:none", "aria-hidden": "true" }),
      });
    }
    return this.instance;
  }

  /** Same object as `getInstance().config.globalProperties` (typed for helpers / entities / services). */
  public static get globalProperties(): ComponentCustomProperties {
    return this.getInstance().config
      .globalProperties as ComponentCustomProperties;
  }
}
